import { render, staticRenderFns } from "./PlanesTratamiento.vue?vue&type=template&id=7b7f3f0c&scoped=true"
import script from "./PlanesTratamiento.vue?vue&type=script&lang=js"
export * from "./PlanesTratamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7f3f0c",
  null
  
)

export default component.exports